export default "__VITE_ASSET__eb11b306__"